import React from 'react';

function SkipToContent() {
  return (
    <ul role="tablist" className="fixed z-50 p-0 m-2 font-bold" tabIndex="0">
      <li>
        <a
          className="px-5 sr-only focus:not-sr-only focus:text-white focus:bg-black focus:block"
          href="#about"
          aria-label="Skip to About"
          role="tab"
        >
          Skip to About
        </a>
      </li>
      <li>
        <a
          className="px-5 sr-only focus:not-sr-only focus:text-white focus:bg-black focus:block"
          href="#skills"
          aria-label="Skip to Skills"
          role="tab"
        >
          Skip to Skills
        </a>
      </li>
      <li>
        <a
          className="px-5 sr-only focus:not-sr-only focus:text-white focus:bg-black focus:block"
          href="#projects"
          aria-label="Skip to Projects"
          role="tab"
        >
          Skip to Projects
        </a>
      </li>
      <li>
        <a
          className="px-5 sr-only focus:not-sr-only focus:text-white focus:bg-black focus:block"
          href="#links"
          aria-label="Skip to Links"
          role="tab"
        >
          Skip to Links
        </a>
      </li>
      <li>
        <a
          className="px-5 sr-only focus:not-sr-only focus:text-white focus:bg-black focus:block"
          href="#contact"
          aria-label="Skip to Contact"
          role="tab"
        >
          Skip to Contact
        </a>
      </li>
    </ul>
  );
}

export default SkipToContent;
